import React from "react";

// SVG prio icons matching Jira-style priority indicators
export default function PrioIcon({ prio, size = 16 }) {
  const s = size;

  switch (prio) {
    case "critical":
      // Red bookmark/flag
      return (
        <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
          <path d="M4 1h8v14l-4-3-4 3V1z" fill="#e5391a" />
        </svg>
      );
    case "major":
      // Red triple chevron up
      return (
        <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
          <path d="M3 6.5l5-3.5 5 3.5" stroke="#e5391a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3 10.5l5-3.5 5 3.5" stroke="#e5391a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3 14.5l5-3.5 5 3.5" stroke="#e5391a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "highest":
      // Orange double chevron up
      return (
        <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
          <path d="M3 9l5-4 5 4" stroke="#e5391a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3 13l5-4 5 4" stroke="#e5391a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "high":
      // Red/orange single chevron up
      return (
        <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
          <path d="M3 10l5-5 5 5" stroke="#e5391a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "medium":
      // Orange/yellow two horizontal bars (equals)
      return (
        <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
          <rect x="2" y="5" width="12" height="2.2" rx="1" fill="#e97f33" />
          <rect x="2" y="9" width="12" height="2.2" rx="1" fill="#e97f33" />
        </svg>
      );
    case "low":
      // Blue single chevron down
      return (
        <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
          <path d="M3 6l5 5 5-5" stroke="#2684ff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "lowest":
      // Blue double chevron down
      return (
        <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
          <path d="M3 3l5 4 5-4" stroke="#2684ff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3 7l5 4 5-4" stroke="#2684ff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "minor":
      // Blue triple chevron down
      return (
        <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
          <path d="M3 1.5l5 3.5 5-3.5" stroke="#2684ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3 5.5l5 3.5 5-3.5" stroke="#2684ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3 9.5l5 3.5 5-3.5" stroke="#2684ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case "backlog":
      // Gray circle outline
      return (
        <svg width={s} height={s} viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="8" r="5.5" stroke="#8993a4" strokeWidth="2" />
        </svg>
      );
    default:
      return null;
  }
}
